<template>
  <div id="aprovarNovosUsuariosWrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Aprovar novos usuários" breakpoint="xl" />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-container fluid>
            <b-row class="m-2 d-flex justify-content-center">
              <b-col cols="12">
                <default-form-validation-provider label="Situação:" rules="">
                  <b-form-radio-group
                    id="situacoes"
                    v-model="valorDropDown"
                    :options="textosDropDown"
                    buttons
                    button-variant="light"
                    @change="pageChange(1)"
                    style="display: inline-flex; flex-wrap: wrap"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="4" xl="4" class="px-xl-2 px-sm-2 px-0">
                <default-form-validation-provider label="Nome ou CPF:" rules="">
                  <b-form-input id="input-nome" v-model="valorInput" />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="4" xl="4" class="px-xl-2 px-sm-2 px-0">
                <default-form-validation-provider label="E-mail:" rules="">
                  <b-form-input id="input-email" v-model="valorEmail" />
                </default-form-validation-provider>
              </b-col>
            </b-row>
            <b-row class="m-2 d-flex justify-content-center">
              <b-col cols="auto" class="mx-2 my-1 my-xl-0">
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  @click="limparFiltro"
                >
                  <font-awesome-icon icon="redo" class="mr-1" />Limpar
                </b-button>
              </b-col>
              <b-col cols="auto" class="mx-2 my-1 my-xl-0">
                <b-button size="sm" @click="pageChange(1)">
                  <font-awesome-icon
                    icon="magnifying-glass"
                    class="mr-1"
                  />Buscar
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </CardFiltrosBusca>
        <b-table
          :items="items"
          :fields="fields"
          :busy="carregandotabela"
          striped
          hover
          no-border-collapse
          sort-by=""
          :sort-desc="true"
          stacked="xl"
          show-empty
        >
          <template #empty>
            <span>Não foram encontrados resultados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(acao)="data">
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="openModalNovoUsuario(data.item.ID_NOVO_USUARIO)"
              ><font-awesome-icon icon="user-pen"
            /></b-button>
          </template>
        </b-table>
        <div
          v-if="totalRows"
          class="d-flex justify-content-center overflow-auto"
        >
          <table-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            @pageChange="pageChange"
          />
        </div>
      </b-card-body>
    </b-card>

    <ModalNovoUsuario
      v-if="abrirModalNovoUsuario"
      :itemSelecionado="itemSelecionado"
      :formatar-situacao="editSituacao"
      @editar="openModalEditarUsuario"
      @editarmail="openModalEditarEmail"
      @alterar="openModalAlteracoes"
      @reload="reload"
      @simplereload="reload(false)"
      @close="closeModalNovoUsuario"
    />

    <ModalEditarUsuario
      v-if="abrirModalEditarUsuario"
      :itemSelecionado="itemSelecionado"
      @reload="reload"
      @close="closeModalEditarUsuario"
    />

    <ModalEditarEmail
      v-if="abrirModalEditarEmail"
      :itemSelecionado="itemSelecionado"
      @reload="reload"
      @close="closeModalEditarEmail"
    />

    <ModalAlteracoes
      v-if="abrirModalAlteracoes"
      :idUsuario="String(itemSelecionado.ID_NOVO_USUARIO)"
      @reload="reload"
      @close="closeModalAlteracoes"
    />
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { store } from "@/store";

import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import usuarioService from "@/services/administracao/usuarioService";
import { TableField } from "@/types/table-field";

import { NovoUsuario } from "@/types/administracao/usuarios/novo-usuario";

import ModalAlteracoes from "@/components/administracao/aprovar-novos-usuarios/ModalAlteracoes.vue";
import ModalNovoUsuario from "@/components/administracao/aprovar-novos-usuarios/ModalNovoUsuario.vue";
import ModalEditarUsuario from "@/components/administracao/aprovar-novos-usuarios/ModalEditarUsuario.vue";
import ModalEditarEmail from "@/components/administracao/aprovar-novos-usuarios/ModalEditarEmail.vue";
import { fieldsNovosUsuarios } from "@/types/administracao/aprovar-novos-usuarios/fields-novos-usuarios";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";

const CompProps = Vue.extend({
  name: "AprovarNovosUsuarios",
  components: {
    HeaderSagres,
    CardFiltrosBusca,
    DefaultFormValidationProvider,
    ModalAlteracoes,
    ModalNovoUsuario,
    ModalEditarUsuario,
    ModalEditarEmail,
    TablePagination,
  },
});

@Component
export default class AprovarNovosUsuarios extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsNovosUsuarios;
  abrirModalAlteracoes = false;
  abrirModalEditarUsuario = false;
  abrirModalEditarEmail = false;
  abrirModalNovoUsuario = false;
  idSelecionado: null | string = null;

  itemSelecionado: NovoUsuario = new NovoUsuario({});
  items: NovoUsuario[] = [];

  currentPage = 1;
  totalRows = 10;
  perPage = 10;

  valorInput = "";
  valorNome = "";
  valorCPF = "";
  valorEmail = "";
  valorDropDown = "pendente validacao";

  textosDropDown = [
    { value: "", text: "Todas" },
    { value: "entregue", text: "Entregue" },
    { value: "pendente validacao", text: "Validação Pendente" },
    { value: "pendente dados", text: "Dados Pendentes" },
    { value: "concluido", text: "Concluído" },
    { value: "cancelado", text: "Cancelado" },
  ];

  editSituacao(situacao: string): string {
    switch (situacao) {
      case "entregue":
        return "Entregue";
      case "pendente validacao":
        return "Validação pendente";
      case "pendente dados":
        return "Dados pendentes";
      case "concluido":
        return "Concluído";
      case "cancelado":
        return "Cancelado";
      default:
        return situacao;
    }
  }

  carregandotabela = false;

  async mounted() {
    await this.pageChange(1);
  }

  async pageChange(value: number) {
    this.currentPage = value;
    await this.carregarUsuarios();
  }

  async carregarUsuarios() {
    try {
      this.carregandotabela = true;
      this.verificaTexto(this.valorInput);
      const response = await usuarioService.listarNovosUsuarios(
        this.currentPage,
        this.valorNome,
        this.valorCPF,
        this.valorDropDown,
        this.valorEmail
      );
      const listaNovosUsuarios: NovoUsuario[] = response.items;
      listaNovosUsuarios.map((item) => {
        item.SITUACAO = this.editSituacao(item.SITUACAO);
        item.NOME = this.capitalize(item.NOME);
        item.CPF = this.formatarCPF(item.CPF);
      });
      this.items = listaNovosUsuarios;
      this.totalRows = response.total;
    } catch (e: any) {
      this.items = [];
      this.totalRows = 0;
      this.tratarError(e);
    } finally {
      this.carregandotabela = false;
    }
  }

  limparFiltro() {
    this.valorInput = "";
    this.valorNome = "";
    this.valorCPF = "";
    this.valorEmail = "";
  }

  verificaTexto(texto: string) {
    const isNumeric = (string: string) => Number.isFinite(+string);
    isNumeric(texto) ? (this.valorCPF = texto) : (this.valorNome = texto);
  }

  async reload(open = true) {
    try {
      store.blockScreen = true;
      await this.carregarUsuarios();
      if (this.idSelecionado && open)
        this.openModalNovoUsuario(this.idSelecionado);
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  async openModalNovoUsuario(id: string) {
    try {
      this.idSelecionado = id;
      store.blockScreen = true;
      const response = await usuarioService.getNovoUsuarioById(String(id));
      this.itemSelecionado = response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
    this.abrirModalNovoUsuario = true;
  }

  closeModalNovoUsuario() {
    this.abrirModalNovoUsuario = false;
  }

  openModalAlteracoes() {
    this.abrirModalAlteracoes = true;
  }

  closeModalAlteracoes() {
    this.abrirModalAlteracoes = false;
  }

  openModalEditarUsuario() {
    this.abrirModalEditarUsuario = true;
  }

  closeModalEditarUsuario() {
    this.abrirModalEditarUsuario = false;
  }

  openModalEditarEmail() {
    this.abrirModalEditarEmail = true;
  }

  closeModalEditarEmail() {
    this.abrirModalEditarEmail = false;
  }

}
</script>

<style>
#situacoes > label {
  border: 0.1px solid gray;
}
</style>